module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8r9n2r5r-2406c49eb560a7c43e9cc0131203e415.svg";